import React from "react";
import { Card, CardBody, Heading } from "@pancakeswap-libs/uikit";
import styled from "styled-components";
import { Timeline } from "react-twitter-widgets";
import useI18n from "hooks/useI18n";
import "./index.css";

const StyledTwitterCard = styled(Card)`
  margin-left: auto;
  margin-right: auto;
  background: linear-gradient(
    162.44deg,
    #000000 49.97%,
    rgba(0, 0, 0, 0) 98.44%
  );
  border: 1px solid #ffffff;
  box-sizing: border-box;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 20px;
  height: 450px;
  overflow-y: scroll;
`;

const TwitterCard = () => {
  const TranslateString = useI18n();
  const load = () => {
    // const bGround: any[]= Array.from(iframe)as HTMLCollectionOf<HTMLElement>
  };
  return (
    <StyledTwitterCard>
      <CardBody>
        <Heading
          style={{
            fontSize: "24px",
            fontWeight: 600,
            width: "203px",
            margin: "auto",
            marginBottom: "24px",
          }}
          size="xl"
        >
          {TranslateString(10003, "Announcements")}
        </Heading>

        <Timeline
          dataSource={{
            sourceType: "profile",
            screenName: "vEmpireDDAO",
          }}
          onLoad={load}
          options={{
            theme: "dark",
            height: "300",
            chrome: "noheader, nofooter",
            width: "100%",
          }}
        />
      </CardBody>
    </StyledTwitterCard>
  );
};

export default TwitterCard;
